import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { RootState } from './app/store';
import NewRoom from './new';

export default function NewRoomGuard () {
	const { profile } = useSelector((state: RootState) => state.user)
	const [component, setComponent] = useState(<></>)
	const navigate = useNavigate();
	useEffect(() => {
		if (profile.id)
		{
			navigate("/main")
		} else
		{
			setComponent(<NewRoom />)
		}
	}, [profile, navigate])

	return (
		<div>
			{component}
		</div>
	)
}
